import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // Same contrast treatment as the impersonation banner's button on the orange banner.
  signOutButton: {
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    fontSize: 16
  }
});

export default makeStyles(styles);
